import GoogleSheet from "@/assets/js/models/GoogleSheet/GoogleSheet";
import startCase from "lodash-es/startCase";

export default {
    filter: {
        search: {
            placeholder: 'تصفية الأوراق حسب الاسم'
        }
    },
    table: {
        name: 'اسم',
        email: 'البريد الألكتروني',
        status: 'الحالة',
        inserts_orders_form: 'إدراج الطلبات من',
        actions: 'خيارات'
    },
    statuses: {
        [GoogleSheet.ACTIVE_STATUS]: 'نشيط',
        [GoogleSheet.INACTIVE_STATUS]: 'غير نشيط',
    },
    form: {
        important_alert: {
            important: 'مهم!',
            please_share: 'يرجى مشاركة (كمحرر) ورقة Google الخاصة بك مع',
            to_allow: 'للسماح بتحديثات الطلب.'
        },
        create: {
            title: 'إنشاء ورقة جوجل',
            button: 'إنشاء ورقة جوجل',
        },
        edit: {
            title: 'تعديل ورقة جوجل',
            button: 'حفظ ورقة جوجل',
        },
        dialogs: {
            delete_sheet: {
                title: 'حذف ورقة جوجل',
                content: 'هل أنت متأكد أنك تريد حذف ورقة Google هذه؟',
            }
        },
        buttons: {
            create: 'إنشاء ورقة جوجل',
            save: 'حفظ ورقة جوجل',
            cancel: 'إلغاء'
        },
        fields: {
            name: {
                title: 'اسم',
                placeholder: 'اكتب اسمًا لهذه الحالة',
                hint: 'أعط أي اسم لإعداد ورقتك'
            },
            sheet_url: {
                title: 'عنوان URL للورقة',
                placeholder: 'https://docs.google.com/spreadsheets/d/XXXXXXXXX/edit?usp=sharing',
            },
            insert_orders_from: {
                title: 'إدراج الطلبات من',
                subTitle: 'من أين تريد الحصول على الطلبات؟'
            },
            from_warehouses: {
                title: 'من المستودعات',
            },
            from_anywhere: {
                title: 'من أي مكان',
            },
            from_stores: {
                title: 'من المتاجر',
            },
            from_sale_pages: {
                title: 'من صفحات البيع',
            },
            from_products: {
                title: 'من المنتجات',
            },
            order_columns: {
                title: 'أعمدة الطلب',
                subTitle: 'يمكنك تغيير ترتيب الأعمدة، ويمكنك تمكينه/تعطيله كما تريد.',
                order_id: 'معرف الطلب',
                order_date: 'تاريخ الطلب',
                customer_name: 'اسم العميل',
                phone_number: 'رقم الهاتف',
                shipping_address: 'عنوان الشحن',
                customer_country: 'بلد العميل',
                customer_country_code: 'رمز بلد العميل',
                city: 'المدينة',
                custom_city: 'الإسم الخاص للمدينة',
                region: 'المنطقة',
                custom_region: ' الإسم الخاص للمنطقة',
                postal_code: 'رمز بريدي',
                product_name: 'اسم المنتج',
                offer_name: 'اسم العرض',
                product_sku: 'رمز المنتج',
                quantity: 'الكمية',
                unit_price: 'سعر الوحدة',
                total_price: 'السعر الإجمالي',
                payment_method: 'طريقة الدفع',
                currency: 'العملة',
            }
        }
    }
}